import Http from './../http';

const prefix = '/split-test';

export const addTest = (params) => {
  return Http.authApi().post(`${prefix}/add-test`, params);
};

export const addPage = (params) => {
  return Http.authApi().post(`${prefix}/add-page`, params);
};

export const deletePage = (params) => {
  return Http.authApi().delete(`${prefix}/page/${params.test_id}/${params.page_id}`);
};

export const deleteTest = (params) => {
  return Http.authApi().delete(`${prefix}/test/${params.test_id}`);
};

export const getDataTests = (test_id) => {
  return Http.authApi().get(`${prefix}/test/${test_id}`);
}



// WEBPACK FOOTER //
// ./src/js/services/editor/splitTests.js